// @flow
import itemsAdded from 'app/common/redux/actions/feeds/itemsAdded';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { AggregatedComment } from 'app/packages/pinterest-flow-types/comment';
import type { Thunk } from 'app/common/redux/types';
import { FEED_TYPE } from 'app/common/redux/reducers/feeds';
import {
  type CommentObjectType,
  COMMENT_OBJECT_TYPES,
} from 'app/common/redux/reducers/aggregatedComments';

const OBJECT_TYPE_TO_CREATE_RESOURCE_MAP = {
  [COMMENT_OBJECT_TYPES.aggregatedComment]: 'AggregatedCommentReplyResource',
  [COMMENT_OBJECT_TYPES.pin]: 'AggregatedCommentResource',
  [COMMENT_OBJECT_TYPES.didIt]: 'DidItCommentsResource',
};

export type AggregatedCommentCreated = {
  type: 'AGGREGATED_COMMENT_CREATED',
  payload: {
    parentId: string,
    aggregatedComment: AggregatedComment,
  },
};

export function aggregatedCommentCreated(
  parentId: string,
  aggregatedComment: AggregatedComment,
): AggregatedCommentCreated {
  return {
    type: 'AGGREGATED_COMMENT_CREATED',
    payload: {
      parentId,
      aggregatedComment,
    },
  };
}

export type AggregatedCommentCreateData = {
  fromUnifiedComment?: boolean,
  // indicates either the top level aggregated comemnt ID, user did it data ID, or aggregated Pin data ID
  objectId: string,
  objectType: CommentObjectType,
  pinId?: string,
  replyToCommentId?: string, // indicates the reply comment ID this comment is replying to
  tags: string,
  text: string,
};

export function createAggregatedComment({
  fromUnifiedComment,
  objectId,
  objectType,
  pinId,
  replyToCommentId,
  tags,
  text,
}: AggregatedCommentCreateData): Thunk<void> {
  return (dispatch) => {
    const resourceName = OBJECT_TYPE_TO_CREATE_RESOURCE_MAP[objectType];
    const createData = {
      objectId,
      pinId,
      tags,
      text,
      replyToCommentId,
    };

    const feedType =
      objectType === 'pin' && fromUnifiedComment
        ? FEED_TYPE.UNIFIED_COMMENTS
        : FEED_TYPE.AGGREGATED_COMMENTS;

    return ResourceFactory.create(resourceName, createData)
      .callCreate({ showError: false })
      .then((response: Object) => {
        const aggregatedComment = response.resource_response.data;
        dispatch(aggregatedCommentCreated(objectId, aggregatedComment));
        dispatch(
          itemsAdded({
            feedType,
            feedId: objectId,
            itemIds: [aggregatedComment.id],
            itemType: aggregatedComment.type,
          }),
        );
        return response;
      });
  };
}
